import { DashboardConstants } from "src/redux/actions/constant";

const {
    APPLY_THERAPIST_BULK_SIGNATURE_REQUEST,
    APPLY_THERAPIST_BULK_SIGNATURE_SUCCESS,
    APPLY_THERAPIST_BULK_SIGNATURE_FAILURE,
    APPLY_THERAPIST_BULK_SIGNATURE_LOADING,
    APPLY_THERAPIST_BULK_SIGNATURE_RESET,
} = DashboardConstants;

const intitialstate: object = {
  response: null,
  isBulkSignature: false,
  loading: false,
};

export const therapistBulkSignatureReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case APPLY_THERAPIST_BULK_SIGNATURE_SUCCESS: {
      return {
        ...state,
        isBulkSignature: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case APPLY_THERAPIST_BULK_SIGNATURE_FAILURE:
      return {
        ...state,
        isBulkSignature: false,
        errorMessage: action.payload,
        response: action.payload,
        loading: false,
      };
     
    case APPLY_THERAPIST_BULK_SIGNATURE_RESET:
        return intitialstate  

    case APPLY_THERAPIST_BULK_SIGNATURE_LOADING:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
